import { render, staticRenderFns } from "./EnderecoPanel.vue?vue&type=template&id=51a87832&"
import script from "./EnderecoPanel.vue?vue&type=script&lang=js&"
export * from "./EnderecoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports